import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ClinicSearchComponent } from './clinic-search.component';
import { AutocompleteSelectorModule } from '../autocomplete-selector/autocomplete-selector.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ClinicSearchComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    AutocompleteSelectorModule,
    TranslateModule
  ],
  exports: [
    ClinicSearchComponent
  ],
  providers: [],
})
export class ClinicSearchModule {}
